import { Component, Input } from '@angular/core';

import { AGUToastService, AGUToastState } from './toast.service';

/**
 * The phone toast bar (`.mtoast`, P/Member_Hub.html:702-706): rendered once by the surface, painting `AGUToastService`'s state.
 * A `role="status"` live region, so the message is announced without taking focus. It rises over the bottom tabs, a little higher on
 * a detail view's action bar (:706) and down to the edge while the tabs are tucked away (:710).
 */
@Component({
    standalone: false,
    selector: 'agu-toast',
    templateUrl: './toast.component.html',
    styleUrl: './toast.component.scss',
})
export class AGUToastComponent {
    /** On a detail view (`html.mdetail`, :706). */
    @Input() Detail = false;
    /** While the bottom tabs are tucked away (`html.mtabs-hide`, :710). */
    @Input() TabsHidden = false;

    constructor(private readonly toast: AGUToastService) {}

    get State(): AGUToastState {
        return this.toast.State;
    }

    RunAction(): void {
        this.toast.RunAction();
    }
}
